/**
 * 增强@kk/request
 * 便于增加异步的请求拦截器操作
 * https://codeup.aliyun.com/61c1c178fa282c88e103c790/fe/web-modules/common/blob/master/request%2FREADME.md
 * 增强后，原来的request.before会作为最后一个执行的请求的拦截器
 * 增强后，原来的request.after会作为第一个执行的响应的拦截器
 * 可以通过request.interceptors.request.use() 在request.before前增加异步的请求拦截器，执行顺序同use的调用顺序
 * 可以通过request.interceptors.response.use() 在request.after后增加异步的响应拦截器，执行顺序同use的调用顺序
 */
export function enhanceRequest() {
    if (window.request && typeof window.request === 'function') {
        /**
         * 存储原来的request
         */
        const originRequest = window.request;
        const requestInterceptors = [];
        const responseInterceptors = [];
        /**
         * 增强的request
         */
        window.request = async function (opt) {
            if (window.request.before && typeof window.request.before === 'function') {
                // 说明又给request的before赋值了, 更新request的before
                originRequest.before = window.request.before;
            }
            if (window.request.after && typeof window.request.after === 'function') {
                // 说明又给request的after赋值了, 更新request的after
                originRequest.after = window.request.after;
            }
            const option = merge(window.request.defaults, opt);
            try {
                if (requestInterceptors.length > 0) {
                    for (let i = 0; i < requestInterceptors.length; i++) {
                        await requestInterceptors[i](option);
                    }
                }

                const response = await originRequest(option);

                if (responseInterceptors.length > 0) {
                    for (let i = 0; i < responseInterceptors.length; i++) {
                        await responseInterceptors[i](response);
                    }
                }
                return Promise.resolve(response);
            } catch (error) {
                window.request.error && request.error(error);
                return Promise.reject(error);
            }
        };
        window.request.defaults = originRequest.defaults;
        originRequest.defaults = {};
        window.request.interceptors = {
            request: {
                use: function (fn) {
                    requestInterceptors.push(fn);
                },
            },
            response: {
                use: function (fn) {
                    responseInterceptors.push(fn);
                },
            },
        };
    } else {
        console.warn('enhanceRequest：没有发现request函数');
    }
}

/**
 * 来自@kk/request中的merge，保持和原来的逻辑一致
 */
function merge(obj1, obj2) {
    const newObj = JSON.parse(JSON.stringify(obj1));
    for (const i in obj2) {
        if (typeof obj2[i] === 'object' && newObj[i]) {
            newObj[i] = merge(newObj[i], obj2[i]);
        } else {
            newObj[i] = obj2[i];
        }
    }
    return newObj;
}
